export default __webpack_public_path__ + "static/media/885.b7247de4.png";